let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36Jaa")).then(() => parcelRequire('aQoI6'));